import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import { maplibreGL } from '@maplibre/maplibre-gl-leaflet'
import 'maplibre-gl/dist/maplibre-gl.css'

const OPENFREEMAP_POSITRON_STYLE =
    'https://tiles.openfreemap.org/styles/positron'

export function OpenFreeMapLayer() {
    const map = useMap()

    useEffect(() => {
        const layer = maplibreGL({
            style: OPENFREEMAP_POSITRON_STYLE,
            interactive: false
        }).addTo(map)

        return () => {
            map.removeLayer(layer)
        }
    }, [map])

    return null
}
